import { DataHandlerUserAdmin, User } from "luxedo-data"
import { createDataStore } from "luxedo-comps/stores"

export const AccountsStore = createDataStore<User>(DataHandlerUserAdmin)
